<div class="container-fluid main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div *ngIf="!(afAuth.user | async)" class="alert alert-warning">
      You must be signed in to submit this form. Please <a href="/landing">sign in</a>.
    </div>

    <div class="card-body">
      <h1 class="custom-card-title text-left">New Grant</h1>
      <h4 class="text-left">Please Fill Out the Following Form</h4>
      <br>

      <form #grantForm=ngForm>
        <div class="mb-3">
          <label for="status">Grant Status: <span class="text-danger">*</span></label>
          <select id="status" class="form-select" [(ngModel)]="formData.status" name="status" required #status="ngModel"
                  [ngClass]="{'is-invalid': status.invalid && status.touched}">
            <option value="" disabled selected>Choose a Status</option>
            <option value="cyclical">Cyclical</option>
            <option value="ongoing">Ongoing</option>
            <option value="clearing house">Clearing house</option>
          </select>
        </div>

        <div class="mb-3">
          <label for="name"><span class="text-danger">*</span> Grant Name:</label>
          <input id="name" class="form-control" [(ngModel)]="formData.name" name="name" required #name="ngModel"
                 [ngClass]="{'is-invalid': name.invalid && name.touched}">
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label for="applicationOpenDate" class="me-2"><span class="text-danger">*</span> Grant Application
              Open:</label>
            <input id="applicationOpenDate" type="date" class="form-control" [(ngModel)]="formData.applicationOpenDate"
                   name="openDate" required #openDate="ngModel"
                   [ngClass]="{'is-invalid': openDate.invalid && openDate.touched}">
          </div>

          <div class="col-6">
            <label for="applicationCloseDate" class="me-2"><span class="text-danger">*</span> Grant Application
              End:</label>
            <input id="applicationCloseDate" type="date" class="form-control"
                   [(ngModel)]="formData.applicationCloseDate" name="closeDate" required #closeDate="ngModel"
                   [ngClass]="{'is-invalid': closeDate.invalid && closeDate.touched}">
          </div>
        </div>

        <div class="mb-3">
          <label for="link" class="me-2"><span class="text-danger">*</span> Grant Web link:</label>
          <input id="link" type="url" class="form-control" [(ngModel)]="formData.webLink" name="link" required
                 #link="ngModel" [ngClass]="{'is-invalid': link.invalid && link.touched}">
        </div>

        <div class="mb-3">
          <label for="description" class="me-2"><span class="text-danger">*</span> Grant Description:</label>
          <input id="description" type="text" class="form-control" [(ngModel)]="formData.description" name="description"
                 required #description="ngModel" [ngClass]="{'is-invalid': description.invalid && description.touched}">
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label for="contactPhone" class="me-2"><span class="text-danger">*</span> Grant Contact Phone
              Number:</label>
            <input id="contactPhone"
                   type="text"
                   class="form-control"
                   [(ngModel)]="formData.contactPhone"
                   name="contactPhone"
                   required
                   maxlength="10"
                   minlength="10"
                   #contactPhone="ngModel"
                   [ngClass]="{'is-invalid': contactPhone.invalid && contactPhone.touched}"
                   (keydown)="allowNumbersOnly($event)">
          </div>

          <div class="col-6">
            <label for="contactName" class="me-2"><span class="text-danger">*</span> Grant Contact Name:</label>
            <input id="contactName"
                   type="text"
                   class="form-control"
                   [(ngModel)]="formData.contactName"
                   name="contactName"
                   required
                   #contactName="ngModel"
                   [ngClass]="{'is-invalid': contactName.invalid && contactName.touched}">
          </div>
        </div>

        <div class="mb-3">
          <label for="amount" class="me-2"><span class="text-danger">*</span> Grant Amount:</label>
          <input id="amount" type="number" class="form-control" [(ngModel)]="formData.amount" name="amount"
                 required #amount="ngModel" [ngClass]="{'is-invalid': amount.invalid && amount.touched}"
                 (keydown)="allowNumbersOnly($event)">
        </div>

        <div class="mb-3">
          <label for="commentary" class="me-2"><span class="text-danger">*</span> Grant Commentary:</label>
          <input id="commentary" type="text" class="form-control" [(ngModel)]="formData.commentary" name="commentary"
                 required #commentary="ngModel" [ngClass]="{'is-invalid': commentary.invalid && commentary.touched}">
        </div>

        <div class="d-flex gap-2 justify-content-center">
          <a routerLink="/grants" class="btn d-flex align-items-center btn-lg"
             style="background-color: red; color: white">
            Cancel without saving
            <span class="material-symbols-outlined ms-1">close</span>
          </a>
          <button id="submitAnnual" type="submit" class="btn btn-primary btn-lg" (click)="submitForm()"
                  [disabled]="!grantForm.valid">Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
